import { render, staticRenderFns } from "./examQuestion.vue?vue&type=template&id=03c8e314&scoped=true"
import script from "./examQuestion.vue?vue&type=script&lang=js"
export * from "./examQuestion.vue?vue&type=script&lang=js"
import style0 from "./examQuestion.vue?vue&type=style&index=0&id=03c8e314&prod&lang=less&scoped=true"
import style1 from "./examQuestion.vue?vue&type=style&index=1&id=03c8e314&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c8e314",
  null
  
)

export default component.exports